export default "__VITE_ASSET__DHtCPuT8__"